<template>
	<section class="app-container invoice__wrapper position-relative">
		
		<div class="h1-buttons-back h1-buttons">
			<div class="d-flex align-items-center min-height-title">
				<a
					class="text-secondary cursor-pointer"
					@click="$router.go(-1)"
				>
					<i class="fas fa-arrow-left"></i>
				</a>
				<h1 class="invoice__heading">
					Invoices
				</h1>
			</div>
			<div class="my-2">
				<div class="invoice__current">
					$ {{ grandTotalCents }}
					<span> Usage {{ currentPeriod }} </span>
				</div>
			</div>
		</div>
		
		<InvoiceList
			v-if="!loading && invoices && invoices.length > 0"
			:invoices="invoices"
			@invoicepaid="getInvoices"
		/>
		<NoData
			:collectionName="'invoices'"
			v-if="!loading && !errMsg && (!invoices || invoices.length === 0)"
		/>
		<ErrorAlert v-if="!loading && errMsg" :error="errMsg" />
		<Spinner v-if="loading" />
	</section>
</template>

<script>
import InvoiceList from "./InvoiceList";
import InvoiceService from "../../services/invoice";
import Spinner from "../shared/Spinner";
import ErrorAlert from "../shared/ErrorAlert";
import NoData from "../shared/NoData";
import dayjs from "dayjs";

export default {
	name: "InvoiceHistory",
	components: {
		InvoiceList,
		Spinner,
		ErrorAlert,
		NoData,
	},
	data() {
		return {
			invoices: [],
			loading: false,
			errMsg: null,
		};
	},
	mounted() {
		this.getInvoices();
	},
	methods: {
		getInvoices() {
			this.loading = true;
			InvoiceService.instance()
				.getInvoices({ page: 0, size: 10 })
				.then((result) => {
					this.loading = false;
					this.errMsg = null;
					this.invoices = result.data.content;
				})
				.catch((err) => {
					this.loading = false;
					this.errMsg = err;
				});
		},
	},
	computed: {
		currentPeriod: function () {
			let currentMonth = dayjs();
			let currentDay = dayjs().date();

			return currentMonth.format("MMMM") + " 1 - " + currentDay;
		},
		grandTotalCents: function () {
			return (this.$store.getters.usage.grandTotalCents / 100).toFixed(2);
		},
	},
};
</script>

<style scoped>
.invoice__wrapper {
	position: relative;
	min-height: 150px;
}
.invoice__heading {
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.invoice__current {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
}
.invoice__current span {
	color: rgba(38, 40, 48, 0.86);
	font-size: 1.2rem;
}
.cursor-pointer:hover {
	cursor: pointer;
}
</style>